export const REMOVE_WORKER = 'REMOVE_WORKER';
export const REMOVE_SHOP = 'REMOVE_SHOP';
export const LOAD_SHOPS = 'LOAD_SHOPS';
export const LOAD_WORKERS_BY_SHOP = 'LOAD_WORKERS_BY_SHOP';
export const LOAD_UNASSIGNED_WORKERS = 'LOAD_UNASSIGNED_WORKERS';
export const LOAD_SHOP_LEADS = 'LOAD_SHOP_LEADS';
export const LOAD_SHOP = 'LOAD_SHOP';
export const ADD_SHOP = 'ADD_SHOP';
export const UPDATE_SHOP = 'UPDATE_SHOP';
export const CHECK_SHOP_UNIQUE = 'CHECK_SHOP_UNIQUE';


export function removeWorker(data) {
  return {
    type: REMOVE_WORKER,
    payload: data
  }
}

export function removeShop(data) {
  return {
    type: REMOVE_SHOP,
    payload: data
  }
}
export function loadShops(data) {
  return {
    type: LOAD_SHOPS,
    payload: data
  }
}
export function loadWorkersByShop(data) {
  return {
    type: LOAD_WORKERS_BY_SHOP,
    payload: data
  }
}
export function loadUnassignedWorkers(data) {
  return {
    type: LOAD_UNASSIGNED_WORKERS,
    payload: data
  }
}
export function loadShopLeads(data) {
  return {
    type: LOAD_SHOP_LEADS,
    payload: data
  }
}
export function loadShop(data) {
  return {
    type: LOAD_SHOP,
    payload: data
  }
}
export function addShop(data) {
  return {
    type: ADD_SHOP,
    payload: data
  }
}
export function updateShop(data) {
  return {
    type: UPDATE_SHOP,
    payload: data
  }
}
export function checkShopUnique(data) {
  return {
    type: CHECK_SHOP_UNIQUE,
    payload: data
  }
}


// WEBPACK FOOTER //
// ./src/actions/shops/index.js